<!-- 刻度盘配置 -->
<template>
  <div>
    <el-form-item label="toolTip辅助指标" label-width="130px">
      <el-switch v-model="main.activeOption.assistTip" size="small"></el-switch>
    </el-form-item>
    <el-collapse accordion>
      <el-collapse-item title="仪表盘">
        <el-form-item label="初始角度">
          <el-input-number v-model="main.activeOption.startAngle" size="small"
                           controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="结束角度">
          <el-input-number v-model="main.activeOption.endAngle" size="small"
                           controls-position="right"></el-input-number>
        </el-form-item>
        <Color :prop="main.activeOption"></Color>
        <el-form-item label="刻度轴宽度">
          <el-input-number v-model="main.activeOption.lineSize" size="small"
                           controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="显示刻度线" v-show="!isRange">
          <el-switch v-model="main.activeOption.axisTickShow" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="刻度线颜色">
          <el-color-picker v-model="main.activeOption.lineColor"></el-color-picker>
        </el-form-item>
        <el-form-item label="显示分隔线" v-show="!isRange">
          <el-switch v-model="main.activeOption.splitLineShow" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="显示刻度值" v-show="!isRange">
          <el-switch v-model="main.activeOption.axisLabelShow" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="刻度间距">
          <el-input-number v-model="main.activeOption.axisLabelDistance" controls-position="right"
                           size="small"></el-input-number>
        </el-form-item>
        <el-form-item label="刻度值字号" v-if="main.activeOption.axisLabelShow">
          <el-input-number v-model="main.activeOption.axisLabelFontSize" size="small"
                           controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="刻度值颜色">
          <el-color-picker v-model="main.activeOption.axisLabelColor"></el-color-picker>
        </el-form-item>
        <el-form-item label="区间数量">
          <el-input-number v-model="main.activeOption.intervalNumber" :min="1" :max="20" @change="setIntervalArray" size="small"
                           controls-position="right"></el-input-number>
        </el-form-item>
        <div v-for="(interval, index) in this.main.activeOption.intervalArray" :key="index">
          <el-form-item :label="`区间${index + 1}值`">
            <el-input-number v-model="interval.intervalValue" size="small" controls-position="right"></el-input-number>
          </el-form-item>
          <el-form-item :label="`区间${index + 1}名`">
            <el-input v-model="interval.intervalName" size="small"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="最小数值" class="min-max">
          <div class="value-control">
            <el-checkbox v-model="main.activeOption.minAuto" label="自动" size="small"/>
            <div style="width: 16px;"></div>
            <el-input-number v-model="main.activeOption.min" size="small" controls-position="right"></el-input-number>
          </div>
        </el-form-item>
        <el-form-item label="最大数值" class="min-max">
          <div class="value-control">
            <el-checkbox v-model="main.activeOption.maxAuto" label="自动" size="small"/>
            <div style="width: 16px;"></div>
            <el-input-number v-model="main.activeOption.max" size="small" controls-position="right"></el-input-number>
          </div>
        </el-form-item>
        <el-form-item label="数值段数" class="min-max">
          <div class="">
            <div>
              <el-radio-group @change="intervalAutoChange" v-model="main.activeOption.intervalAuto" class="ml-4">
                <el-radio value="auto" label="auto">自动</el-radio>
                <el-radio value="range" label="range">区间分段</el-radio>
                <el-radio value="custom" label="custom">自定义</el-radio>
              </el-radio-group>
            </div>
            <el-input-number v-show="main.activeOption.intervalAuto === 'custom'" v-model="main.activeOption.interval"
                             :min="0"
                             size="small"
                             controls-position="right"></el-input-number>
          </div>
        </el-form-item>
        <el-form-item label="指针宽度">
          <el-input-number v-model="main.activeOption.pointerWidth" size="small"
                           controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="指针宽度">
          <el-input v-model="main.activeOption.pointerLength" size="small"></el-input>
        </el-form-item>

        <el-form-item label="指标单位">
          <el-input v-model="main.activeOption.unit" size="small"></el-input>
        </el-form-item>
      </el-collapse-item>
      <el-collapse-item title="标签">
        <el-form-item label="显示标签">
          <el-switch v-model="main.activeOption.labelShow" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="横向分布">
          <el-input-number v-model="main.activeOption.leftOffset" size="small"
                           controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="纵向位置">
          <el-input-number v-model="main.activeOption.topOffset" size="small"
                           controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="标签宽度">
          <el-input-number v-model="main.activeOption.labelWidth" size="small"
                           controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="标签字号">
          <el-input-number v-model="main.activeOption.labelFontSize" size="small"
                           controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="标签字色">
          <el-color-picker v-model="main.activeOption.labelColor" size="small"
                           controls-position="right"></el-color-picker>
        </el-form-item>
        <el-form-item label="标签圆角">
          <el-input-number v-model="main.activeOption.labelRadius" size="small"
                           controls-position="right"></el-input-number>
        </el-form-item>
      </el-collapse-item>
    </el-collapse>

  </div>
</template>

<script>
import Color from './commonSet/color.vue'

export default {
  name: "gauge",
  inject: ["main"],
  components: {Color},
  data() {
    return {
      test: ''
    }
  },
  computed: {
    isRange() {
      return this.main.activeOption.intervalAuto === 'range'
    }
  },
  methods: {
    setIntervalArray(value) {
      this.main.activeOption.intervalArray = Array.from({length: this.main.activeOption.intervalNumber}, () => ({
        intervalValue: 0,
        intervalName: ''
      }))
    },
    intervalAutoChange(v) {
      if (v === 'range') {
        this.main.activeOption.axisTickShow = false
        this.main.activeOption.splitLineShow = false
        this.main.activeOption.axisLabelShow = true
      }
    }
  }
};
</script>

<style>
.value-control {
  display: flex;
  flex-wrap: nowrap;
}
</style>